import React from 'react';
import { paths } from '@AppRoutes/constants';
import history from '@AppRoutes/history';
import { TabGroup } from '@els/els-react--tab-group';
import { trackAdobeAnalyticsPage } from '../analytics';

function HeaderContainer() {
  const handleLinkClick = (route) => {
    trackAdobeAnalyticsPage(route);
  };

  const tabs = [
    {
      id: 'recent',
      label: 'Recent',
      path: 'HISTORY_RECENT',
      route: 'main.history.recent',
      ariaLabel: 'Recent: Your search history on Reaxys from the past six months',
    },
    {
      id: 'saved',
      label: 'Saved',
      path: 'HISTORY_SAVED',
      route: 'main.history.saved',
      ariaLabel: 'Saved: Your saved searches in Reaxys',
    },
  ];

  return (
    <div className="heading-container--history u-els-padding-top u-els-padding-bottom u-els-padding-left-2x u-els-padding-right-2x">
      <h1 id="history-title" className="u-els-font-size-h4">
        History
      </h1>
      <TabGroup
        id="history-tabs"
        className="u-els-margin-top"
        aria-label="History tabs"
        tabs={
          tabs &&
          tabs.map((tab) => (
            <span key={tab.id} id={tab.id} aria-label={tab.ariaLabel}>
              {tab.label}
            </span>
          ))
        }
        hasDivider
        onTabChange={(s) => {
          handleLinkClick(tabs[s]?.route);
          history.push(paths[tabs[s]?.path]);
        }}
      />
    </div>
  );
}

export default HeaderContainer;
